import React, { Component, ErrorInfo, ReactNode } from 'react'
import ErrorFallback from './ErrorBoundary/ErrorFallback'

interface Props {
	children: ReactNode
	fallback?: ReactNode
}

interface State {
	hasError: boolean
	error: Error | null
}

class ErrorBoundary extends Component<Props, State> {
	constructor(props: Props) {
		super(props)
		this.state = {
			hasError: false,
			error: null
		}
	}

	static getDerivedStateFromError(error: Error): State {
		return {
			hasError: true,
			error
		}
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		console.error('ErrorBoundary caught an error:', error, errorInfo)
	}

	render() {
		if (this.state.hasError) {
			return this.props.fallback || <ErrorFallback error={this.state.error} />
		}

		return this.props.children
	}
}

export default ErrorBoundary
